<template>
  <div class="documentsWrapper">
    <span class="sectionTitle">Liste des demandes de remboursement</span>
    <div class="documentsGridWrapper">
      <div class="cardLayoutWrapper cardLayoutWrapper--header">
        <div class="elem elem--span-5">
          <span>N° de demande</span>
        </div>
        <div class="elem elem--span-5">
          <span>Dispositif</span>
        </div>
        <div class="elem elem--span-5">
          <span>N° dossier</span>
        </div>
        <div class="elem elem--span-10">
          <span>Référence</span>
        </div>
        <div class="elem elem--span-5">
          <span>Montant HT</span>
        </div>
      </div>
      <div
        class="gridElemWrapper"
        v-for="(elem, index) in remboursements"
        :key="index"
      >
        <div class="cardLayoutWrapper">
          <div class="elem elem--span-5">
            <span>{{ elem.codeDossier }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ elem.sousDispositif }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ elem.codeDossier }}</span>
          </div>
          <div class="elem elem--span-10 elem--bold elem--nowrap">
            <span>{{ elem.reference }}</span>
          </div>
          <div class="elem elem--span-5">
            <span>{{ formatNumber(elem.montantHt, { decimal: 2, separateur: true }) }} €</span>
          </div>
          <div class="elem elem--span-4">
            <BasicButton
              label="Consulter"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToDRWithKey(elem.idSor)"
            />
          </div>
        </div>
      </div>
      <span
        v-if="!remboursements.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
    <div class="documentsMobileWrapper">
      <div
        class="documentsMobileElemWrapper"
        v-for="(elem, index) in remboursements"
        :key="index"
      >
        <div class="headerWrapper">
          <div class="leftContent">
            <span class="subtitle">{{ elem.codeDossier }}</span>
            <span>{{ elem.sousDispositif }}</span>
            <span>{{ elem.codeDossier }}</span>
            <span>{{ elem.reference }}</span>
            <span>{{ formatNumber(elem.montantHt, { decimal: 2, separateur: true }) }} €</span>
          </div>
          <div class="rightContent">
            <BasicButton
              label="Consulter"
              size="small"
              iconName="eye"
              type="secondary"
              variant="outlined"
              @click="routingService.navigateToDRWithKey(elem.idSor)"
            />
          </div>
        </div>
      </div>
      <span
        v-if="!remboursements.length"
        class="emptyListPlaceholder"
      >
        Aucun élément
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { RemboursementProformaDto } from '@/features/api/extranet/dto/Demande/PROFORMA'
  import { useFactureRoutingService } from '../useFactureRoutingService'
  import { formatNumber } from '@/features/shared/tools'

  const routingService = useFactureRoutingService()

  defineProps<{
    remboursements: RemboursementProformaDto[]
  }>()
</script>

<style scoped lang="less">
  @import '../../index.less';
</style>
